export default "__VITE_ASSET__B_F_5jjt__"